import { createAction, props } from '@ngrx/store';
import { AdminProjectTemplateApiError } from './admin-project-template.errors';
import {
  AdminProjectTemplate,
  CreateAdminProjectTemplate,
  EditAdminProjectTemplate,
} from './models/admin-project-template.model';

export const AdminProjectTemplateListPageOpenedAction = createAction(
  '[Admin Project Template List] Page Opened',
);

export const AdminProjectTemplateListLoaded = createAction(
  '[Admin Project Template Effects] List Loaded',
  props<{ templates: AdminProjectTemplate[] }>(),
);

export const NewAdminProjectTemplateSubmittedAction = createAction(
  '[Admin Project Template List] New Template Submitted',
  props<{ template: CreateAdminProjectTemplate }>(),
);

export const AdminProjectTemplateCreatedAction = createAction(
  '[Admin Project Template Effects] Template Added',
  props<{ template: AdminProjectTemplate }>(),
);

export const DeleteAdminProjectTemplateClickedAction = createAction(
  '[Admin Project Template List] Delete Template Clicked',
  props<{ templateId: number }>(),
);

export const AdminProjectTemplateDeletedAction = createAction(
  '[Admin Project Template Effects] Template Deleted',
);

export const EditAdminProjectTemplatePageOpenedAction = createAction(
  '[Edit Admin Project Template] Page Opened',
  props<{ templateId: number }>(),
);

export const AdminProjectTemplateLoaded = createAction(
  '[Admin Project Template Effects] Template Loaded',
  props<{ template: AdminProjectTemplate }>(),
);

export const EditAdminProjectTemplateSubmittedAction = createAction(
  '[Edit Admin Project Template] Update Submitted',
  props<{ templateId: number; template: EditAdminProjectTemplate }>(),
);

export const AdminProjectTemplateUpdated = createAction(
  '[Admin Project Template Effects] Template Updated',
  props<{ template: AdminProjectTemplate }>(),
);

export const AdminProjectTemplateApiErrored = createAction(
  '[Admin Project Template API] Errored',
  props<{ error: AdminProjectTemplateApiError }>(),
);

export const AddAdminProjectModalDestroyed = createAction(
  '[Add Admin Project Template Modal] Destroyed',
);
